// extracted by mini-css-extract-plugin
export var closeIcon = "styles-module--closeIcon--6a402";
export var content = "styles-module--content--68798";
export var empty = "styles-module--empty--3e31d";
export var layout = "styles-module--layout--072a2";
export var text = "styles-module--text--eaaa5";